import { COLLECTION_IDS } from '@/constants/collections';
import { GET_DEFAULT_CONSTRUCTOR } from '@/constants/constructor';
import PAGES from '@/constants/pages';
import getCarFields from '@/features/cars/helpers/getCarFields';
import {
  ConstructorType,
  ICarCardGridItem,
  IConstructorGrid,
} from '@/interfaces/constructor.interfaces';
import { ISettings } from '@/interfaces/settings.interfaces';
import instanceOfGrid from '@/utils/instanceOfGrid';
import mergeGrid from '@/utils/mergeGrid';

/**
 * Подготавливает параметры запроса автомобиля
 * @param config объект конфигурации приложения
 * @param carId идентификатор автомобиля
 * @returns объект параметров запроса.
 */
const getCarParameters = (config: ISettings, carId?: string) => {
  const { spaceId, envId, constructor } = config;

  // Строим сетку блоков для страницы автомобиля
  const constructorGrid = mergeGrid(
    GET_DEFAULT_CONSTRUCTOR()[PAGES.CarId],
    constructor?.[PAGES.CarId],
  );

  // Формируем конфиг полей автомобилей в разрезе блоков, для сопоставления
  // его с блоками, использующимися на странице.
  let fields = getCarFields(constructorGrid, config);

  const specificationFields = getSpecificationFields(constructorGrid);

  if (specificationFields.length) {
    const fieldsSet = new Set([...fields, ...specificationFields]);

    fields = Array.from(fieldsSet);
  }

  return {
    spaceId,
    envId,
    collectionId: COLLECTION_IDS.vehiclesVehicles,
    itemId: carId,
    options: {
      options: {
        fields,
      },
    },
  };
};

/**
 * Вспомогательная функция, позволяет формировать необходимые поля для
 * блока "Спецификация" карточки автомобиля, на основе пропсов блока.
 *
 * @param items блоки карточки автомобиля
 * @returns массив свойств объекта автомобиля
 */
function getSpecificationFields(constructorGrid: IConstructorGrid): Array<string> {
  for (const item of constructorGrid.items) {
    if ('type' in item && item.type === ConstructorType.CarCardSpecification) {
      const resolvedItem = item as ICarCardGridItem;
      return (
        (resolvedItem?.props?.items as Array<{ key: string }> | undefined)?.map(
          item => item.key,
        ) || []
      );
    }

    if (instanceOfGrid(item)) {
      const specificationKeys = getSpecificationFields(item);

      if (specificationKeys.length) {
        return specificationKeys;
      }
    }
  }

  return [];
}

export default getCarParameters;
